var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('CollapsableCategory',{attrs:{"value":_vm.getHeadline,"color":"#fff","is_disabled":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [((_vm.current_takt_index >= 0 && _vm.current_takt_index < _vm.taktarea.twaggons.length))?_c('div',{staticClass:"taktarea-details-sequence-rework-waggon"},[_vm._l((_vm.getUObjects({
            type: 'tworkpackages',
            ids: _vm.waggons[_vm.current_takt_index].tworkpackages
          })),function(workpackage){return _c('WorkPackageHead',{key:`workpackages${workpackage.id}`,style:(`z-index: 100; cursor: pointer; background-color: ${_vm.getColor(workpackage.color)}`),attrs:{"head":{
            token: workpackage.token,
            name: workpackage.name,
            icon: workpackage.icon,
            area: _vm.taktarea.name,
            status_done_count: _vm.$store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
            status_is_stop: workpackage.stop_status,
          },"location":"ProjectWallet","readonly":false,"is_taktarea_details":true,"foreground_color":"#000"},on:{"selectStatus":function($event){_vm.updateUObject({
              url: [
                {projects: _vm.$route.params.project_id},
                {trains: _vm.train.id},
                {taktareas: _vm.taktarea.id},
                {twaggons: _vm.waggons[_vm.current_takt_index].id},
                {tworkpackages: workpackage.id},
              ],
              url_suffix: $event.tooltip.toLowerCase() !== 'stop'? '/status':'/stopstatus',
              update: $event.tooltip.toLowerCase() !== 'stop'?
              {status: workpackage.status !== $event.tooltip.toLowerCase()?$event.tooltip.toLowerCase():'none'}
              :
              {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
            })},"clickStopStatus":function($event){return _vm.$router.push({
              name: _vm.getUseOnSite ? `${_vm.location}WorkPackageWorkSteps`:`${_vm.location}WorkPackageInfo`,
              params: {
                train_id: _vm.train.id,
                taktarea_id: _vm.taktarea.id,
                twaggon_id: _vm.waggons[_vm.current_takt_index].id,
                tworkpackage_id: workpackage.id,
                takt_index: _vm.current_takt_index + _vm.train.train_start + _vm.taktarea.taktarea_start + _vm.takt_offset,
                direction: 'all',
                nav_back: `${_vm.location}TaktareaDetailsInfo`
              }
            })}},nativeOn:{"click":function($event){return _vm.$router.push({
              name: _vm.getUseOnSite ? `${_vm.location}WorkPackageWorkSteps`:`${_vm.location}WorkPackageInfo`,
              params: {
                train_id: _vm.train.id,
                taktarea_id: _vm.taktarea.id,
                twaggon_id: _vm.waggons[_vm.current_takt_index].id,
                tworkpackage_id: workpackage.id,
                takt_index: _vm.current_takt_index + _vm.train.train_start + _vm.taktarea.taktarea_start + _vm.takt_offset,
                direction: 'all',
                nav_back: `${_vm.location}TaktareaDetailsInfo`
              }
            })}}})}),(_vm.getUObjects({
            type: 'tworkpackages',
            ids: _vm.waggons[_vm.current_takt_index].tworkpackages
          }).length === 0)?_c('TText',{staticClass:"empty-waggon",attrs:{"value":"Empty Waggon"}}):_vm._e()],2):_vm._e(),(_vm.location == 'ProjectWallet' && _vm.getCurrentTaktIndex(_vm.$route.params.project_id) != _vm.takt_index)?_c('div',[_vm._v(" You're not in the current Takttime. ")]):_vm._e(),(_vm.current_takt_index < 0)?_c('div',[_vm._v(" Next WorkPackge in: "+_vm._s(-1 * _vm.current_takt_index)+" Takts ")]):_vm._e(),(_vm.current_takt_index >= _vm.taktarea.twaggons.length)?_c('div',[_vm._v(" Last WorkPackge was: "+_vm._s(_vm.current_takt_index - _vm.taktarea.twaggons.length + 1)+" Takts ago ")]):_vm._e()]},proxy:true}])}),_c('CollapsableCategory',{attrs:{"value":_vm.$t('WorkpackageRework.Info.Description'),"color":"#fff","is_disabled":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('DisableableInputField',{staticClass:"mt-2 mb-2",attrs:{"label":"Description","value":_vm.taktarea.description,"is_disabled":!_vm.isEditMode,"background_color":'#424242',"foreground_color":'#fff'},on:{"change":function($event){return _vm.updateUObject({
          url: [
            { projects: _vm.$route.params.project_id },
            { trains: _vm.$route.params.train_id },
            { taktareas: _vm.$route.params.taktarea_id }
          ],
          update: {
            description: $event
          }
        })}}})]},proxy:true}])}),_c('CollapsableCategory',{attrs:{"value":"Size","color":"#fff","is_disabled":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('DisableableInputField',{staticClass:"mt-2 mb-2",attrs:{"label":"Size (m²)","value":_vm.taktarea.square_meter,"is_disabled":!_vm.isEditMode,"background_color":'#424242',"foreground_color":'#fff'},on:{"change":function($event){_vm.updateUObject({
          url: [
            { projects: _vm.$route.params.project_id },
            { trains: _vm.$route.params.train_id },
            { taktareas: _vm.$route.params.taktarea_id }
          ],
          update: {
            square_meter: parseInt($event)
          }
        })}}}),_vm._v(" "+_vm._s()+" ")]},proxy:true}])}),_c('CollapsableCategory',{attrs:{"value":"Sequence","color":"#fff","is_disabled":false},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed }){return [(is_collapsed)?_c('div',{staticClass:"taktarea-details-sequence-rework"},_vm._l((_vm.waggons),function(waggon,waggon_index){return _c('div',{key:`waggon${waggon.id}${waggon_index}`,staticClass:"taktarea-details-sequence-rework-waggon"},[_vm._l((_vm.getUObjects({
              type: 'tworkpackages',
              ids: waggon.tworkpackages
            })),function(workpackage){return _c('WorkPackageHead',{key:`workpackages${workpackage.id}`,style:(`z-index: 100; cursor: pointer; background-color: ${_vm.getColor(workpackage.color)}`),attrs:{"head":{
              token: workpackage.token,
              name: workpackage.name,
              icon: workpackage.icon,
              area: _vm.taktarea.name,
              status_done_count: _vm.$store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
              status_is_stop: workpackage.stop_status,
            },"location":"ProjectWallet","readonly":false,"is_taktarea_details":true,"foreground_color":"#000"},on:{"selectStatus":function($event){_vm.updateUObject({
              url: [
                {projects: _vm.$route.params.project_id},
                {trains: _vm.train.id},
                {taktareas: _vm.taktarea.id},
                {twaggons: waggon.id},
                {tworkpackages: workpackage.id},
              ],
              url_suffix: $event.tooltip.toLowerCase() !== 'stop'? '/status':'/stopstatus',
              update: $event.tooltip.toLowerCase() !== 'stop'?
              {status: workpackage.status !== $event.tooltip.toLowerCase()?$event.tooltip.toLowerCase():'none'}
              :
              {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
            })},"clickStopStatus":function($event){return _vm.$router.push({
              name: _vm.getUseOnSite ? `${_vm.location}WorkPackageWorkSteps`:`${_vm.location}WorkPackageInfo`,
              params: {
                train_id: _vm.train.id,
                taktarea_id: _vm.taktarea.id,
                twaggon_id: waggon.id,
                tworkpackage_id: workpackage.id,
                takt_index: waggon_index + _vm.train.train_start + _vm.taktarea.taktarea_start + _vm.takt_offset,
                direction: 'all',
                nav_back: `${_vm.location}TaktareaDetailsInfo`
              }
            })}},nativeOn:{"click":function($event){return _vm.$router.push({
                name: _vm.getUseOnSite ? `${_vm.location}WorkPackageWorkSteps`:`${_vm.location}WorkPackageInfo`,
                params: {
                  train_id: _vm.train.id,
                  taktarea_id: _vm.taktarea.id,
                  twaggon_id: waggon.id,
                  tworkpackage_id: workpackage.id,
                  takt_index: waggon_index + _vm.train.train_start + _vm.taktarea.taktarea_start + _vm.takt_offset,
                  direction: 'all',
                  nav_back: `${_vm.location}TaktareaDetailsInfo`
                }
              })}}})}),(_vm.getUObjects({
              type: 'tworkpackages',
              ids: waggon.tworkpackages
            }).length === 0)?_c('TText',{staticClass:"empty-waggon",attrs:{"value":"Empty Waggon"}}):_vm._e()],2)}),0):_vm._e()]}}])}),_c('CollapsableCategory',{attrs:{"value":_vm.$t('WorkpackageRework.Info.Extras'),"color":"#fff","is_disabled":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('WorkPackageWidgetList',{attrs:{"widgets":[
          { icon: 'qr-code', text: 'QR-Codes', route_name: `${_vm.location}TaktareaDetailsQRCodes`, params: {} },
          { icon: 'person-helmet', text: 'WORK.steps', route_name: `${_vm.location}TaktareaDetailsSteps`, params: { step_type: 'Work' } },
          { icon: 'tram', text: 'Sequence', route_name: `${_vm.location}TaktareaDetailsSequence`, params: {} },
          { icon: 'sign-sum', text: 'Quantities', route_name: `${_vm.location}TaktareaDetailsQuantities`, params: {} },
          { icon: 'window-new', text: 'Show TAKTarea in PROJECT.structure'},

          /* { icon: 'mdi-qrcode', text: 'QR-Codes', route_name: `${location}TaktareaDetailsQRCodes`, params: {} }, */
          /* { icon: 'mdi-account-hard-hat', text: 'WORK.steps', route_name: `${location}TaktareaDetailsSteps`, params: { step_type: 'Work' } }, */
          /* { icon: 'mdi-train', text: 'Sequence', route_name: `${location}TaktareaDetailsSequence`, params: {} }, */
        ],"items_per_row":_vm.location === 'ProjectWallet' ? 4: 8,"background_color":"#fff","foreground_color":"#fff","is_small_icons":true},on:{"setActive":function($event){if ($event.icon === 'visibility-on') {
          // Use Widget as Button for multiWindow
          _vm.openMultiWindow($event);
        } else {
          _vm.$router.push({
            name: _vm.$route.name.includes($event.route_name)?`${_vm.location}TaktareaDetailsInfo`:`${$event.route_name}`,
            params: $event.params
          })
        }}}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }